import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Typography,
  Divider,
  Box,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

// Helper formatters
const fmtDate = (iso) => {
  if (!iso) return "-";
  try {
    const data = new Date(iso);
    return data?.toLocaleString();
  } catch (e) {
    return iso;
  }
};

const fmtNumber = (n) => {
  if (n === null || n === undefined) return "-";
  if (typeof n === "number") return n.toLocaleString();
  const parsed = Number(n);
  return Number.isNaN(parsed) ? n : parsed.toLocaleString();
};

const SectionTitle = ({ children }) => (
  <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
    {children}
  </Typography>
);

const PaymentDetailsDialog = ({ open, onClose, data }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <Typography variant="h6">Payment / Order Details</Typography>
          <Typography variant="caption">
            Order: {data?.orderId} • Item: {data?.orderItemId}
          </Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <IconButton size="small" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <SectionTitle>Identifiers & Dates</SectionTitle>
            <Typography variant="body2">
              NEFT ID: {data?.neftId || "-"}
            </Typography>
            <Typography variant="body2">
              NEFT Type: {data?.neftType || "-"}
            </Typography>
            <Typography variant="body2">
              Payment Date: {fmtDate(data?.paymentDate)}
            </Typography>
            <Typography variant="body2">
              Order Date: {fmtDate(data?.orderDate)}
            </Typography>
            <Typography variant="body2">
              Dispatch Date: {fmtDate(data?.dispatchDate)}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <SectionTitle>Product & Fulfilment</SectionTitle>
            <Typography variant="body2">
              Seller SKU: {data?.sellerSku}
            </Typography>
            <Typography variant="body2">
              Quantity: {fmtNumber(data?.quantity)}
            </Typography>
            <Typography variant="body2">
              Category: {data?.productSubCategory}
            </Typography>
            <Typography variant="body2">
              Fulfilment Type: {data?.fulfilmentType}
            </Typography>
            <Typography variant="body2">
              Additional Info: {data?.additionalInformation}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ my: 1 }} />
          </Grid>

          <Grid item xs={12} sm={6}>
            <SectionTitle>Buyer & Price</SectionTitle>
            <Typography variant="body2">
              Buyer Sale Amount: ₹ {fmtNumber(data?.buyerSaleAmount)}
            </Typography>
            <Typography variant="body2">
              Buyer Total Offer: ₹ {fmtNumber(data?.buyerTotalOfferAmount)}
            </Typography>
            <Typography variant="body2">
              Buyer Total Amount: ₹ {fmtNumber(data?.buyerTotalAmount)}
            </Typography>
            <Typography variant="body2">
              Buyer My Share: ₹ {fmtNumber(data?.buyerMyShare)}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <SectionTitle>Marketplace Fees & Taxes</SectionTitle>
            <Typography variant="body2">
              Marketplace Fee: ₹ {fmtNumber(data?.marketplaceFee)}
            </Typography>
            <Typography variant="body2">
              Commission Rate: {fmtNumber(data?.commissionRate)}%
            </Typography>
            <Typography variant="body2">
              Commission: ₹ {fmtNumber(data?.commission)}
            </Typography>
            <Typography variant="body2">
              GST on MP Fees: ₹ {fmtNumber(data?.gstOnMpFees)}
            </Typography>
            <Typography variant="body2">
              TDS: ₹ {fmtNumber(data?.tds)}
            </Typography>
            <Typography variant="body2">
              TCS: ₹ {fmtNumber(data?.tcs)}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ my: 1 }} />
          </Grid>

          <Grid item xs={12} sm={6}>
            <SectionTitle>Shipping & Weights</SectionTitle>
            <Typography variant="body2">
              Shipping Fee: ₹ {fmtNumber(data?.shippingFee)}
            </Typography>
            <Typography variant="body2">
              Reverse Shipping Fee: ₹ {fmtNumber(data?.reverseShippingFee)}
            </Typography>
            <Typography variant="body2">
              Volumetric Weight: {fmtNumber(data?.volumetricWeight)}
            </Typography>
            <Typography variant="body2">
              Dimensions: {data?.lengthBreadthHeight}
            </Typography>
            <Typography variant="body2">
              Shipping Zone: {data?.shippingZone}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <SectionTitle>Adjustments & Others</SectionTitle>
            <Typography variant="body2">
              Total Offer Amount: ₹ {fmtNumber(data?.totalOfferAmount)}
            </Typography>
            <Typography variant="body2">
              Offer Adjustments: ₹ {fmtNumber(data?.offerAdjustments)}
            </Typography>
            <Typography variant="body2">
              Refund: ₹ {fmtNumber(data?.refund)}
            </Typography>
            <Typography variant="body2">
              Bank Settlement Value: ₹ {fmtNumber(data?.bankSettlementValue)}
            </Typography>
            <Typography variant="body2">
              Protection Fund: ₹ {fmtNumber(data?.protectionFund)}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ my: 1 }} />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};
export default PaymentDetailsDialog;
